import React from 'react'
import { useFieldArray } from 'react-hook-form'
import { DEFAULT_PRODUCT } from '_utils/constant'
import { FaList, FaPlus } from 'react-icons/fa'
import ProductItem from './ProductItem'
import ProductItemIndividual from './ProductItemIndividual'
import ModalFromProduct from '../CreateItem/components/ModalFromProduct'
import { useModal } from '../../../hooks/useModal'
import { getUserInfo, getDeviceUser } from '../../../utils/localData'
import { DESKTOP } from '../../../utils/constant'

const ProductList = (props) => {
  const deviceUser = getDeviceUser()
  const currentUser = getUserInfo()
  const { control, register, setValue, errors, watch, fromConfirm, onEdit } = props
  const {
    fields,
    append: appendProduct,
    insert: insertProduct,
    remove: removeProduct,
  } = useFieldArray({
    control,
    name: 'products',
  })

  const watchFieldArray = watch('products')
  const controlledFields = fields.map((field, _index) => ({
    ...field,
    ...watchFieldArray[_index],
  }))

  const swapProduct = (oldIndex, newIndex) => {
    const a = controlledFields[oldIndex]
    const b = controlledFields[newIndex]
    const subItemA = a.subItems
    const subItemB = b.subItems

    setValue(`products.${oldIndex}`, b)
    setValue(`products.${newIndex}`, a)
    setValue(`products.${oldIndex}.subItems`, subItemB)
    setValue(`products.${newIndex}.subItems`, subItemA)
  }
  // console.log('controlledFields:', controlledFields)
  const modalFromProduct = useModal()

  return (
    <>
    <div className='detail-list-news'>
      {controlledFields.map((item, index) => (
        <React.Fragment key={index}>
          <ProductItem
            productIndex={index}
            totalListProduct={controlledFields?.length}
            isIndividual={false}
            {...{
              control,
              register,
              appendProduct,
              insertProduct,
              removeProduct,
              swapProduct,
              watch,
              setValue,
              errors,
            }}
            product={item}
          />
          {item?.splitCasePurchase &&
            typeof item.splitCasePurchase === 'object' &&
            item.splitCasePurchase !== null &&
            item.splitCasePurchase.itemsPerCase && (
              <ProductItemIndividual
                productIndex={index}
                totalListProduct={controlledFields?.length}
                isIndividual={true}
                {...{
                  control,
                  register,
                  appendProduct,
                  insertProduct,
                  removeProduct,
                  swapProduct,
                  watch,
                  setValue,
                  errors,
                }}
                product={item}
                fromConfirm={fromConfirm}
                onEdit={onEdit}
              />
            )}
        </React.Fragment>
      ))}
      <div className='mt-4 d-flex justify-content-between gap-2'>
        <button type='button' className='button-add-item' onClick={() => appendProduct({ ...DEFAULT_PRODUCT })}>
          <FaPlus />
          <span>Add Items</span>
        </button>
        {
          currentUser?.isUsingFeature && deviceUser === DESKTOP && (
            <button type='button' className='button-add-from-product' onClick={modalFromProduct.openModal}>
              <FaList/>
              <span>Add from Product</span>
            </button>
          )
        }
      </div>
    </div>
    <ModalFromProduct
        isOpen={modalFromProduct.isOpen}
        toggle={modalFromProduct.toggleModal}
        closeModal={modalFromProduct.closeModal}
        onAdd={(newItems) => {
          newItems.forEach((item) => appendProduct(item))
        }}
      />
    </>
  )
}

export default ProductList
